import { VinceApp } from 'vince-core/composables/usePermission';
import { useMenuStore } from 'vince-core/stores/menuStore';
import { ResourceType } from 'vince-core/types/common';
import { Menu } from 'vince-core/types/menu';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    store.addMenuItem('menuItems.dashboard', '/dashboards', 1, Menu.MAIN, undefined, 'pi pi-dashboards', {
        app: VinceApp.FND,
        resource: ResourceType.DASHBOARD,
        resourceId: '*',
        action: '*'
    }
    );
});
